import { createFileRoute, Link } from '@tanstack/react-router';
import { Alert, Anchor, Group, Stack } from '@mantine/core';
import { IconRocket } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { PlatformRole, hasRole, useSession } from '../auth/session';
import { TesterScreen } from '../features/tester/TesterScreen';
import { BackLink } from '../components/BackLink';

/**
 * The configuration tester gets its own URL because it is the link somebody pastes into an incident
 * channel. Every check on it is read-only; only filing a pasted report writes anything.
 */
export const Route = createFileRoute('/tenants_/$tenantId_/tester')({
  component: TesterPage,
});

function TesterPage() {
  const { t } = useTranslation(['tenants', 'onboarding']);
  const { tenantId } = Route.useParams();
  const { data: session } = useSession();

  const canView = hasRole(session, PlatformRole.Viewer, tenantId);
  const canFileReport = hasRole(session, PlatformRole.TenantAdmin, tenantId);

  return (
    <Stack gap="sm">
      <Group gap="md">
        <BackLink to="/tenants/$tenantId" params={{ tenantId }} search={{ tab: 'settings' }} />
        {/* Link carries the styling so the router generics stay intact for `params`. */}
        <Link to="/tenants/$tenantId/onboarding" params={{ tenantId }} style={{ textDecoration: 'none' }}>
          <Anchor
            component="span"
            size="sm"
            c="dimmed"
            underline="never"
            style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}
          >
            <IconRocket size={14} />
            {t('onboarding:title')}
          </Anchor>
        </Link>
      </Group>

      {!canView ? (
        <Alert color="red" title={t('tenants:noAccessTenantTitle')}>
          {t('tenants:noRoleBody')}
        </Alert>
      ) : (
        <TesterScreen tenantId={tenantId} canFileReport={canFileReport} />
      )}
    </Stack>
  );
}
